import { CoreModule, LicenseManager } from 'dynamsoft-barcode-reader-bundle'

//LicenseManager.initLicense('DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAzMjQ5MDMxLVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTAzMjQ5MDMxIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjotMjA2ODgwNzgyOH0=')
LicenseManager.initLicense('DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAyOTA0NzYwLVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTAyOTA0NzYwIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tIiwiY2hlY2tDb2RlIjo0NjYwODIzMTZ9')

CoreModule.engineResourcePaths = {
    std: 'https://cdn.jsdelivr.net/npm/dynamsoft-capture-vision-std@1.2.10/dist/',
    dip: 'https://cdn.jsdelivr.net/npm/dynamsoft-image-processing@2.2.30/dist/',
    core: 'https://cdn.jsdelivr.net/npm/dynamsoft-core@3.2.30/dist/',
    license: 'https://cdn.jsdelivr.net/npm/dynamsoft-license@3.2.21/dist/',
    cvr: 'https://cdn.jsdelivr.net/npm/dynamsoft-capture-vision-router@2.2.30/dist/',
    dbr: 'https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader@10.2.10/dist/',
    dce: 'https://cdn.jsdelivr.net/npm/dynamsoft-camera-enhancer@4.0.3/dist/'
}

CoreModule.loadWasm(['DBR'])
